export default __webpack_public_path__ + "static/media/export-2.8ba1c7b7.svg";